export const SubscriptionStatus = {
    PENDING_ACTIVATION: "Pending Activation",
    ACTIVE: "Active",
    EXPIRED: "Expired",
    PENDING_RENEWAL: "Pending Renewal",
    BANNED: "Disabled"
}